/**
* Component: AssetViews.jsx
* Description: This component is utilized for to view the full details of the particular asset.
*/

import React, { useEffect, useState } from 'react';
import { Typography, Box, IconButton, Stack, Divider, Grid, DialogActions, Button, DialogContent, Dialog, DialogTitle, useMediaQuery } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import DownloadIcon from '@mui/icons-material/Download';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { BreadcrumbBar } from '../../assets/styled-components/breadcrumbBar';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import CloseIcon from '@mui/icons-material/Close';
import { SuccessChips, ErrorChips } from '../../assets/styled-components/chips';
import { DefaultCard } from '../../assets/styled-components/card';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AssetRecordTab from './AssetRecordTab';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { format } from 'date-fns';
import { BemsGraph, FemsGraph, MasterGraph } from '../../utility/apiURLS';
import { getAuthToken, getcompanyId } from '../../utility/tokenUtility';
import axios from 'axios';
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import { gridValues, serviceType } from '../../redux/actions/assetActions';
import moment from 'moment/moment';


function AssetViews() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    //get the company id from local storage
    const companyId = getcompanyId("companyId");
    
    const selectedGridData = useSelector((state) => state.gridValues.selectedGridData);
    const assetCategoryType=location.state?.assetCategoryType;
    const [openAssetDetailModal, setOpenAssetDetailModal] = useState(false);
    const [value, setValue] = useState('1');
    const [gridApi, setGridApi] = useState(null);
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const [attachement, setAttachment] = useState([]);
    const [vendorDetails, setVendorDetails] = useState([]);
    const assetType = assetCategoryType === "/assetsFEM" ? FemsGraph : BemsGraph;
    const checkFemorBem = assetCategoryType === "/assetsFEM" ? "fem" : "bem";

    //get the attachments from api
    const fetchOptions = async () => {
        const getId=location.state?.id;
        const getVales=location.state?.values;
        const getIsEdit=location.state?.isEdit;
        const getIsView=location.state?.isView;
        const getUpdatedRows=location.state?.updatedRows;

        dispatch(gridValues({ values: getVales, isEdit: getIsEdit, isView: getIsView, updatedRows: getUpdatedRows }));

        try {
            const id = selectedGridData?.values?.assetId || getId;
            const config = {
                headers: {
                    Authorization: `Bearer ${getAuthToken('id_token')}`
                }
            }
            const attachment = await axios.get(`${assetType}/api/GraphAssetregister/GetAssetRegisterAttachmentsList/${id}`, config);
            //if the uploaded file in redux then set the uploaded file in grid
            if (attachment?.data?.length > 0) {
                const formatResponse = attachment?.data?.map((item) => {
                    const filenameWithoutExtension = item?.documenttitle?.split('.').slice(0, -1).join('.');
                    const fileExtension = item?.documenttitle?.split('.').pop();
                    // const size = (parseFloat(item?.filesize?.split(' ')[0]) / 1024).toFixed(2) + ' MB';
                    const size = item?.filesize;
                    return {
                        ...item,
                        fileName: filenameWithoutExtension,
                        fileType: fileExtension?.toUpperCase(),
                        size: size
                    }
                })
                setAttachment(formatResponse);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const fetchVendor = async () => {
        try {

            const config = {
                headers: {
                    Authorization: `Bearer ${getAuthToken('id_token')}`
                }
            }

            const response = await axios.get(
                `${MasterGraph}/api/GraphMaspomvendors/GetMaspomvendorsByFacilityId/${companyId}?Size=100000`,
                config
            );
            setVendorDetails(response.data); // Update state with fetched vendor details
        } catch (error) {
            console.error('Error fetching vendor details:', error);
            setVendorDetails([]); // Fallback to an empty array on error
        }
    };

    // Function to map vendor ID to vendor name
    const mapToVendorDetails = (id) => {
        const vendor = vendorDetails?.find(v => v?.id === id);
        return vendor ? vendor.vendorname : ''; // Return vendor name or an empty string if not found
    };

    // Fetch options and vendor details on component mount
    useEffect(() => {
        fetchOptions();
        fetchVendor();
    }, []);


    //To Open the asset view detail modal
    const handleOpenAssetDetailModal = () => {
        setOpenAssetDetailModal(true);
    };

    //To close the asset view detail modal
    const handleCloseAssetDetailModal = () => {
        setOpenAssetDetailModal(false);
    };

    //Onchange  AssetView modal
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    //Handling Back Click in AssetView Page
    const handleBackClick = () => {
        navigate(`${assetCategoryType}`);
    };

    //function to hanlde download the file. if the file is stored then it will download from db otherwise it will download from grid
    const handleDownload = async (fileId, documenttitle) => {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${getAuthToken('id_token')}`
                }
            }
            if (fileId) { //this will handle edit time or store time download
                const response = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${fileId}`, {
                    ...config,
                    responseType: 'blob'
                });
                if (response) {
                    const url = URL.createObjectURL(response.data);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = documenttitle;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            } else {
                console.log(fileId + "fileId Not found");
            }
        } catch (error) {
            console.log('Error downloading file:', error);
        }
    };

    //Download the attachement file Icon
    const handleDownloadClick = (event, row) => {
        event.preventDefault(); // Prevent default link behavior (redirect)
        handleDownload(row?.filename, row?.fileName);
    };

    const valuesArray = [selectedGridData?.values]; //Covert array of object for asset record tab grid

    //Convert Date Format
    const formatDate = (dateString) => {
        if (!dateString) {
            return '';
        }
        const formattedDate = format(new Date(dateString), 'dd/MM/yyyy');
        return formattedDate;
    };
    
    const basicDetails = [
        { label: 'Loaner/Rental Asset', value: selectedGridData?.values?.isloanerasset ? "Yes" : "No" },
        { label: 'T&C No.', value: selectedGridData?.values?.testingandcommissionvalue },
        { label: 'Asset Classification', value: selectedGridData?.values?.assetClassificationCode },
        { label: 'Finance Asset No.', value: selectedGridData?.values?.finanaceassetno },
        { label: 'Asset Description', value: selectedGridData?.values?.assetDescription },
        { label: 'Type Code', value: selectedGridData?.values?.assetTypeCode },
        { label: 'Type Code Description', value: selectedGridData?.values?.typedescription },
        { label: 'Location Name', value: selectedGridData?.values?.locationdesc },
        { label: 'Location No.', value: selectedGridData?.values?.locationNo },
        { label: 'User Department', value: selectedGridData?.values?.userDepartmentCode },
        { label: 'Department Description', value: selectedGridData?.values?.userDescription },
        { label: 'Criticality', value: selectedGridData?.values?.criticalityvalue },
        { label: 'Work Group', value: selectedGridData?.values?.workgroup },
        { label: 'PPM Required', value: selectedGridData?.values?.isppmrequiredflag ? "Yes" : "No"  },
        { label: 'PPM Status', value: selectedGridData?.values?.[`${checkFemorBem}assetppmstatusId`] === 2
            ? "Inhouse"
            : selectedGridData?.values?.[`${checkFemorBem}assetppmstatusId`] === 1
            ? "Outsource"
            : selectedGridData?.values?.[`${checkFemorBem}assetppmstatusId`] === 3
            ? "N/A"
            : "" },
        { label: 'Reason', value: selectedGridData?.values?.reason },
    ];

    const assetSpecification = [
        { label: 'Make', value: `${selectedGridData?.values?.make}` },
        { label: 'Brand', value: selectedGridData?.values?.brand },
        { label: 'Model', value: selectedGridData?.values?.model },
        { label: 'Serial No', value: selectedGridData?.values?.serialno },
        { label: 'Engine No', value: selectedGridData?.values?.engineno },
        { label: 'Chassis No', value: selectedGridData?.values?.chassisno },
        { label: 'Asset Version', value: selectedGridData?.values?.version },
        { label: 'Manufacturer', value: selectedGridData?.values?.manufacturer },
        { label: 'Registeration No', value: selectedGridData?.values?.registerationno },
        { label: 'Built-up Area (Sq.m)', value: selectedGridData?.values?.builtuparea },
        { label: 'Foot Print', value: selectedGridData?.values?.footprint },
        { label: 'Land Area (Sq.m)', value: selectedGridData?.values?.landarea },
        { label: 'Capacity', value: selectedGridData?.values?.capacity },
        { label: 'Asset Status', value: selectedGridData?.values?.assetStatus },
        { label: 'Life Span(Yrs)', value: selectedGridData?.values?.lifespan },
        { label: 'Depreciation Value', value: selectedGridData?.values?.depreciationvalue },
    ];

    const femassetTransfer = selectedGridData?.values?.femassetpurchasecostflag?.femassetregisters[0]?.femassettransfer?.assettransfer;
    const bemassetTransfer = selectedGridData?.values?.bemassetpurchasecostflag?.bemassetregisters[0]?.bemassettransfer?.assettransfer;
    const assetTransfer = assetCategoryType === '/assetsFEM' ? femassetTransfer : bemassetTransfer;
    const serivceType = assetCategoryType === "/assetsFEM" ? selectedGridData?.values?.femassetpurchasecostflag?.purchasecostflag : selectedGridData?.values?.bemassetpurchasecostflag?.purchasecostflag;

    const purchaseDetails = [
        { label: 'Purchase Order No.', value: selectedGridData?.values?.purchaseorderno },
        { label: 'Purchase Cost in RM.', value: parseFloat(selectedGridData?.values?.purchasecost || 0)?.toFixed(2) || "" },
        { label: 'Purchase Flag', value: serivceType },
        { label: 'Warranty Start Date', value: moment(selectedGridData?.values?.warrantystartdate).format('DD/MM/YYYY') },
        { label: 'Warranty End Date', value: moment(selectedGridData?.values?.warrantyenddate).format('DD/MM/YYYY') },
        { label: 'Commissioning Date', value: formatDate(selectedGridData?.values?.commissioningdate) },
        { label: 'Accessories', value: selectedGridData?.values?.accessories },
        { label: 'Vendor', value: mapToVendorDetails(selectedGridData?.values?.vendorid) },
        { label: 'Cumulative Part Cost in (RM).', value: selectedGridData?.values?.cumpartscost },
        { label: 'Last Scheduled Work Order', value: selectedGridData?.values?.lastscheduledworkorder },
        { label: 'Last UnScheduled Work Order', value: selectedGridData?.values?.lastunscheduledworkorder },
        { label: 'Asset Transfer Category', value: assetTransfer },
        { label: 'Asset Transfer Department', value: selectedGridData?.values?.departmentdesc },
        { label: 'Asset Transfer Hospital', value: selectedGridData?.values?.hospitaldesc },
    ];

    const attachmentColumns = [
        {
            field: 'fileName',
            headerName: 'File Name',
            flex: 1,
            editable: true,
            minWidth: isSmallScreen ? 80 : 120,
        },
        {
            field: 'fileType',
            headerName: 'File Type',
            flex: 1,
            editable: true,
            minWidth: isSmallScreen ? 80 : 120,
        },
        {
            field: 'size',
            headerName: 'Size',
            flex: 1,
            editable: true,
            minWidth: isSmallScreen ? 80 : 120,
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            flex: 1,
            minWidth: 160,
            cellClassName: 'actions',
            cellRenderer: (params) => (
                <>
                    <Button onClick={(event) => handleDownloadClick(event, params.data)}>
                        {params?.data?.fileName ? <DownloadIcon /> : <></>}
                    </Button>
                </>
            ),
        }
    ]

    return (
        <>
            <BreadcrumbBar >
                <Stack direction={'row'} alignItems={'center'} gap={1.5} divider={<Divider orientation="vertical" flexItem />}>
                    <IconButton aria-label="home" disableRipple >
                        <HomeIcon />
                    </IconButton>
                    <Typography mb={0} variant='title2'>{assetCategoryType === "/assetsFEM" ? "View Asset Register - FEMS" : "View Asset Register - BEMS"}</Typography>
                </Stack>
                {/* <Stack direction={'row'} alignItems={'center'} gap={1.5}>
                    <Typography>Help</Typography>
                    <IconButton sx={{
                        width: '30px',
                        height: '30px',
                        background: '#FFF',
                        borderRadius: '50%',
                        borderTopRightRadius: '0',
                        border: '1px solid #F0EDF2',
                        padding: '20px'
                    }}>
                        <ChevronLeftIcon sx={{ color: '#FFF', background: '#A77BCA', borderRadius: '50%' }} />
                    </IconButton>
                </Stack> */}
            </BreadcrumbBar >
            <Stack my={{ xs: 1, md: 2 }} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                <Stack direction={'row'} alignItems={'center'} gap={1.5}>
                    <IconButton onClick={handleBackClick} sx={{ backgroundColor: 'background.tableHeader' }}>
                        <ArrowBackIcon data-testid="back-button" />
                    </IconButton>
                    <Typography m={0} variant='title2' color={'text.primary'} fontWeight={400}>{selectedGridData?.values?.assetno || selectedGridData?.values?.assetNo}</Typography>
                </Stack>
                {selectedGridData?.values?.isauthorized === true ? <SuccessChips label='Authorized' /> : <ErrorChips label='Unauthorized' />}
            </Stack>
            <DefaultCard my={{ xs: 1, md: 2.5 }}>
                <Stack mb={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'} >
                    <Typography m={0} variant='h6' color={'text.secondary'} fontWeight="bold">Asset Details</Typography>
                    {/* {/ Handling view Modal Icon /} */}
                    <Stack direction={'row'} alignItems={'center'} display={'inline-flex'} gap={1.5}>
                        <Typography m={0} fontWeight={500} color={'text.primary'} >View Detail</Typography>
                        <IconButton sx={{ backgroundColor: 'background.tableHeader' }} onClick={handleOpenAssetDetailModal} data-testid="view-detail-button"><ArrowOutwardIcon /></IconButton>
                    </Stack>
                </Stack>
                <Grid container spacing={{ xs: 1, md: 3 }}>
                    <Grid item xs={6} sm={4} md={3} lg={2}>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.primary'} fontWeight="bold" >Asset Description</Typography>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.secondary'}>{selectedGridData?.values?.assetDescription || ""}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3} lg={2}>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.primary'} fontWeight="bold">Asset Classification</Typography>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.secondary'}>{selectedGridData?.values?.assetClassificationCode || ""}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3} lg={2}>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.primary'} fontWeight="bold">Type Code</Typography>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.secondary'}>{selectedGridData?.values?.assetTypeCode || 0}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3} lg={2}>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.primary'} fontWeight="bold">Location Name</Typography>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.secondary'}>{selectedGridData?.values?.locationdesc || ""}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3} lg={2}>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.primary'} fontWeight="bold">User Department</Typography>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.secondary'}>{selectedGridData?.values?.userDepartmentCode || ""}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3} lg={2}>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.primary'} fontWeight="bold" >Location No.</Typography>
                        <Typography mb={{ xs: 1, md: 1.5 }} color={'text.secondary'}>{selectedGridData?.values?.locationNo || 0}</Typography>
                    </Grid>
                </Grid>
            </DefaultCard>

            <DefaultCard>
                {/* {/ Tab Changing for Grid Values /} */}
                <AssetRecordTab rows={valuesArray} />

            </DefaultCard>
            {/* {/ Asset Detail Modal  /} */}
            <Dialog open={openAssetDetailModal} fullWidth maxWidth={'md'} PaperProps={{
                sx: {
                    height: { xs: '73vh', sm: '73vh', md: '73vh', lg: '80vh' },
                    marginTop: { xs: '10%', sm: '10%', md: '7%', lg: '7%' },
                    marginLeft: { xs: '10%', sm: '15%', md: '10%', lg: '10%' },
                    backgroundColor: '#FAFAFA'
                }
            }}>
                <DialogTitle>
                    <Stack direction={'row'} alignItems={'center'}>
                        <Typography m={0} variant='title2' color={'text.secondary'}>{selectedGridData?.values?.assetno || selectedGridData?.values?.assetNo}</Typography>
                        <IconButton sx={{ marginLeft: 'auto' }} onClick={handleCloseAssetDetailModal} data-testid="close-detail-button"><CloseIcon /></IconButton>
                    </Stack>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange} aria-label="Tab" variant='scrollable'>
                                    <Tab label="Basic & Specifications" value="1" />
                                    <Tab label="Purchase & Warranty" value="2" />
                                    <Tab label="Attachments" value="3" />
                                </TabList>
                            </Box>
                            {/* {/ { Basic Details Tab } /} */}
                            <TabPanel value="1">
                                <Box p={{ xs: 1, md: 2 }} bgcolor={'background.paper'}>
                                    <Typography mb={2} variant='h4' color={'text.secondary'} fontWeight={500} >Basic Details</Typography>
                                    <Grid container spacing={{ xs: 2, md: 3 }} >
                                        {basicDetails?.map(({ label, value }) => (
                                            <Grid item xs={12} sm={6} md={3} key={label}>
                                                <Typography mb={{ xs: 1, sm: 1, md: 1.5 }} color={'text.primary'} fontWeight="bold">{label}</Typography>
                                                <Typography mb={{ xs: 1, sm: 1, md: 1.5 }} color={'text.secondary'}>{value || ""}</Typography>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                                {/* {/ {  Specifications Tab } /} */}
                                <Box p={{ xs: 1, md: 2 }} mb={{ xs: 2, md: 3 }} bgcolor={'background.paper'}>
                                    <Typography mb={2} variant='h4' color={'text.secondary'} fontWeight={500} >Asset Specification</Typography>
                                    <Grid container spacing={{ xs: 2, md: 3 }}>
                                        {assetSpecification?.map(({ label, value }) => (
                                            <Grid item xs={12} sm={6} md={3} key={label}>
                                                <Typography mb={{ xs: 1, sm: 1, md: 1.5 }} color={'text.primary'} fontWeight="bold">{label}</Typography>
                                                <Typography mb={{ xs: 1, sm: 1, md: 1.5 }} color={'text.secondary'}>{value || ""}</Typography>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                            </TabPanel>

                            {/* {/ { Purchase & Warranty Tab } /} */}
                            <TabPanel value="2">
                                <Box p={{ xs: 1, md: 2 }} mb={{ xs: 2, md: 3 }} bgcolor={'background.paper'}>
                                    <Grid container spacing={{ xs: 2, md: 3 }}>
                                        {purchaseDetails?.map(({ label, value }) => (
                                            <Grid item xs={12} sm={6} md={3} key={label}>
                                                <Typography mb={{ xs: 1, sm: 1, md: 1.5 }} color={'text.primary'} fontWeight="bold">{label}</Typography>
                                                <Typography mb={{ xs: 1, sm: 1, md: 1.5 }} color={'text.secondary'}>{value || ""}</Typography>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                            </TabPanel>

                            {/* {/ { Attachments Tab } /} */}
                            <TabPanel value="3">
                                <CustomAgGrid
                                    rows={attachement}
                                    columns={attachmentColumns}
                                    setGridApi={setGridApi}               
                                />
                            </TabPanel>
                        </TabContext>
                    </Box>
                </DialogContent>
            </Dialog>

        </>
    );
};

export default AssetViews;